import Vue from 'vue';
import Vuex from 'vuex'

import { AppState } from './modules/app'
import { HeartBookState } from './modules/heartBook'
import { AssetsState } from './modules/asset';
import { ToolbarState } from './modules/toolbar';
import { ErrorState } from './modules/error';

Vue.use(Vuex);

export interface IRootState {
    app: AppState,
    assets: AssetsState
    toolbar: ToolbarState
    errors: ErrorState
    heartBook: HeartBookState
}

export const store = new Vuex.Store<IRootState>({
    strict: true
})